import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

/**
 * TanStack Router instance.
 *
 * The `routeTree` is generated by the Vite plugin from files under
 * `src/routes/`. During the very first dev start, the plugin writes
 * `src/routeTree.gen.ts`; until then, TS will complain — that's expected.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
